(function($){
	
	$(document).ready(function() {
		
		//var $link = $('<a id="apiLogin" href="#">Login to Learning Portal</a>');
		
		$(document).ready(function() {
			
			if( $('body').hasClass('logged-in') ) {
				
				//$('.top_header .email_box .box_type').prepend($link);

				$('#apiLogin').on('click touch', function(e) {

					e.preventDefault();
					e.stopPropagation();

					$.ajax({
						url: wds.ajaxurl,
						type: 'POST',
						data: {
							'action': 'ajaxredirect',
						},
						success: function(response){

							response = JSON.parse(response);

							if( response.success ) {

								window.open(response.url);

							}

						}
					}); 

					return false;

				});
			}
			
		});
		
	});
	
})(jQuery);